module.exports = __webpack_public_path__ + "img/81.fcdbf9b4.jpg";